import { default as React, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Page from '../layout/Page'
import { Button, Paper } from '@mui/material'
import { default as bus } from '../utils/EventBus'
import ListViewCommandBar from '../commandBar/ListViewCommandBar.js'
import ListExtendedAttributes from './ListExtendedAttributes.js'

export default function ManageExtendedAttributesPage (props = {}) {
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()
  const [listRefreshKey, setListRefreshKey] = useState(new Date().toISOString())
  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  const addRecord = () => {
    console.log('add record')
    bus.emit('add-extended-attribute')
  }

  const breadcrumb = (
    <span>
      <Button
        variant="text"
        onClick={() => navigate('/app/admin')}
        sx={{ minWidth: 0, p: 0, textTransform: 'none' }}
      >
        Application Administration
      </Button>
      {' > '}Manage Extended Attributes
    </span>
  )

  const [showFilters, setShowFilters] = useState(false)
  const toggleFilters = () => {
    setShowFilters(!showFilters)
  }

  return (
    <Page { ...props} breadcrumb={breadcrumb} isLoading={isLoading} 
    commandBar={
      <ListViewCommandBar 
        showFilters={true}
        toggleFilters={toggleFilters} 
        addRecord={addRecord} 
        showAdd={true}              
      />
    }>
      <Paper sx={{margin: '0 auto 1em auto' }}>
          <ListExtendedAttributes
            key={listRefreshKey}
            showFilters={showFilters}
            startLoading={startLoading}
            stopLoading={stopLoading}
            searchFilter={{isActive: false}}
            refresh={() => setListRefreshKey(new Date().toISOString())}
          />
      </Paper>
  </Page>
  )
}